<script>
  export let fill = '#090a0b'
</script>

<svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M0.679826 0.631592C0.255907 0.631592 0.0243286 1.12602 0.295715 1.45168L4.22819 6.17066C4.42809 6.41054 4.79652 6.41054 4.99642 6.17066L8.92889 1.45168C9.20028 1.12602 8.9687 0.631592 8.54478 0.631592H0.679826Z" fill={fill} />
</svg>
